import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useLanguage } from '../../contexts/LanguageContext';

const spanStyle = {
    padding: '20px',
    background: '#efefef',
    color: '#000000'
}

const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: '200px',
    padding: '0 20px'
}

// Desktop settings
const desktopSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 4,
    arrows: false,
    autoplay: false,
    appendDots: (dots) => (
        <div style={{ marginTop: '20px' }}>
            <ul style={{ 
                margin: '0', 
                padding: '0', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                gap: '0px' 
            }}>
                {dots}
            </ul>
        </div>
    ),
    customPaging: () => (
        <div style={{
            width: '10px',
            height: '10px',
            backgroundColor: '#333333',
            borderRadius: '50%',
            opacity: 0.5,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            margin: '0 4px'
        }} />
    )
};

// Mobile settings
const mobileSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
slidesToScroll: 2,
    arrows: false,
    autoplay: false,
    appendDots: (dots) => (
        <div style={{ marginTop: '20px' }}>
            <ul style={{ 
                margin: '0', 
                padding: '0', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                gap: '0px' 
            }}>
                {dots}
            </ul>
        </div>
    ),
    customPaging: () => (
        <div style={{
            width: '10px',
            height: '10px',
            backgroundColor: '#333333',
            borderRadius: '50%',
            opacity: 0.5,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            margin: '0 4px'
        }} />
    )
};

const slideImages = [
    {
        url: 'home/Clients/1.webp',
        width:'200px'
        // caption: 'Slide 1'
    },
    {
        url: 'home/Clients/2.webp',
        width:'200px'
        // caption: 'Slide 2'
    },
    {
        url: 'home/Clients/3.webp',
        width:'200px'
        // caption: 'Slide 3'
    },
    {
        url: 'home/Clients/4.webp',
        width:'200px'
        // caption: 'Slide 4'
    },
    {
        url: 'home/Clients/5.webp',
        width:'200px'
        // caption: 'Slide 5'
    },
    {
        url: 'home/Clients/6.webp',
        width:'200px'
        // caption: 'Slide 6'
    },
    {
        url: 'home/Clients/7.webp',
        width:'200px'
        // caption: 'Slide 7'
    },
    {
        url: 'home/Clients/8.webp',
        width:'200px'
        // caption: 'Slide 8'
    },
    {
        url: 'home/Clients/9.webp',
        width:'200px'
        // caption: 'Slide 9'
    },
    {
        url: 'home/Clients/10.webp',
        width:'200px'
        // caption: 'Slide 10'
    },
    {
        url: 'home/Clients/11.webp',
        width:'200px'
        // caption: 'Slide 11'
    },
    {
        url: 'home/Clients/12.webp',
        width:'200px'
        // caption: 'Slide 12'
    },
    {
        url: 'home/Clients/13.webp',
        width:'200px'
        // caption: 'Slide 13'
    },
    {
        url: 'home/Clients/14.webp',
        width:'200px'
        // caption: 'Slide 14'
    },
];

const OurClients = () => {
    const { t } = useLanguage();
    return (
        <div id='website-responsive' style={{ overflow: 'hidden' }}>
            <div className='left-padding10rem1 right-padding10rem1 py-md-5 py-4'>
                <div className='pb-md-4 pb-3' style={{ color: '#FE9B1F' }}>
                    <center>
                        <div className='fs-ss-38 text-ss-primary text-philos fw-700' >
                            {t('home.ourClients.title')}
                        </div>
                    </center>
                </div>

                <div className='pb-4'>
                    {/* Desktop Slider */}
                    <div className="slide-container d-none d-md-block">
                        <Slider {...desktopSettings}>
                            {slideImages.map((slideImage, index) => (
                                <div key={index}>
                                    <div style={{ ...divStyle }}>
                                        <img src={slideImage.url} alt='' style={{ 
                                            width: '150px', 
                                            height: 'auto', 
                                            maxWidth: '100%', 
                                            objectFit: 'contain',
                                            margin: '0 auto',
                                            display: 'block'
                                        }} />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    {/* Mobile Slider */}
                    <div className="slide-container d-block d-md-none">
                        <Slider {...mobileSettings}>
                            {slideImages.map((slideImage, index) => (
                                <div key={index}>
                                    <div style={{ ...divStyle }}>
                                        <img src={slideImage.url} alt='' style={{ 
                                            width: '120px', 
                                            height: 'auto', 
                                            maxWidth: '100%', 
                                            objectFit: 'contain',
                                            margin: '0 auto',
                                            display: 'block'
                                        }} />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OurClients